import {
  Text,
  Box,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import { IconAlertCircle } from '../../../../../styles/icons';
import {useState, useEffect, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import Lozenge from '../../../../components/common/Lozenge';
import { useUtilityDataSelector } from '../../../../utilities/contexts';
import {updateProfileValue} from "../../../../redux/actions/user";

const EditSectionPractitionerModalities = ({ profile }) => {
  const allPracticeTypes = useUtilityDataSelector((utilityData) => utilityData.therapistPractitionerModalities);
  const [practitionerModalitiesSelection, setPractitionerModalitiesSelection] = useState(allPracticeTypes);
  const dispatch = useDispatch();


  useEffect(() => {
    let newArr = allPracticeTypes?.map((item) => {
      return profile.practitionerModalities
        ?.map((elem) => elem.value)
        .includes(item.value)
        ? { ...item, selected: true }
        : { ...item, selected: false };
    });

    setPractitionerModalitiesSelection(newArr);
  }, [allPracticeTypes, profile]);

  const handleProfileValueUpdate = useCallback((value) => {
    setPractitionerModalitiesSelection(value);
    dispatch(updateProfileValue('practitionerModalities', value.filter((elem) => elem.selected)))
  }, [dispatch]);

  // Render
  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            textAlign="left"
          >
            <Box>
              <Text>Types of therapy offered</Text>
              <Text textStyle="footer2" color="brand.200">
                {profile.practitionerModalities
                  .map((elem) => elem.label)
                  .join(' | ')}
              </Text>
            </Box>
            {profile.practitionerModalities?.length > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Select which types of therapy you offer
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full">
            <h3 className="text-lg text-slate-600 font-bold pb-2 flex items-center">
              Search and select the types of therapy that you provide.
              <p className="text-red-500 superscript text-sm pl-1">*</p>
            </h3>
            <h5 className="pb-4 text-sm text-slate-600 font-light">
              You can select up to 6 types of therapy
            </h5>
            <Lozenge
              title=""
              data={practitionerModalitiesSelection}
              onclick={handleProfileValueUpdate}
              multi
              max={6}
            />
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionPractitionerModalities;
